import React, { useState } from 'react';
import { getTextColor } from './colorUtils';

export default function SwatchCard({ swatch, size = 'md' }) {
  const [copied, setCopied] = useState(false);
  const textColor = getTextColor(swatch.hex);

  const handleClick = () => {
    navigator.clipboard.writeText(swatch.hex).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    });
  };

  const dim = size === 'lg' ? 80 : size === 'sm' ? 44 : 60;

  return (
    <div
      onClick={handleClick}
      title={`${swatch.hex} — click to copy`}
      style={{
        width: dim,
        height: dim,
        background: swatch.hex,
        borderRadius: 4,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '4px 3px',
        boxSizing: 'border-box',
        border: '1px solid rgba(255,255,255,0.08)',
        position: 'relative',
        flexShrink: 0,
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = `0 8px 20px ${swatch.hex}55`;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <span style={{
        fontSize: 9,
        fontFamily: "'Crimson Pro', serif",
        fontWeight: 300,
        color: textColor,
        opacity: 0.85,
        letterSpacing: '0.03em',
        textAlign: 'center',
        lineHeight: 1.1,
      }}>
        {copied ? 'Copied' : swatch.label}
      </span>
      <span style={{
        fontSize: 7.5,
        fontFamily: 'monospace',
        color: textColor,
        opacity: 0.6,
        letterSpacing: '0.05em',
      }}>
        {swatch.hex.toUpperCase()}
      </span>
    </div>
  );
}
